import {
  isHotelProperty,
  isPureUltimate,
  isSiDaProperty,
  isStandard
} from '@merchant-backend/util'
import cls from 'classnames'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { DECORATION } from '../constant'
import style from './style.module.less'

export default inject('pageStore')(
  observer(({ pageStore, forPro }) => {
    const _isUltimate = isPureUltimate()
    const _isStandard = isStandard()
    const { HEADER_ONE, HEADER_ONE_TIP } = pageStore.getPageConfig()
    // console.log(DECORATION(forPro))

    return (
      <div className={style.center}>
        <div className={style.decoration}>
          <h3 className={style.title}>{HEADER_ONE}</h3>
          <p className={style.tip}>{HEADER_ONE_TIP}</p>
          <ul
            className={cls(
              [style['decoration-list']],
              isHotelProperty() ? style['hotel-decoration-list'] : '',
              isSiDaProperty() ? style['sanDa-decoration-list'] : ''
            )}
          >
            {DECORATION(forPro).map((item, index) => {
              // console.log(item)
              if (item.hidden) {
                return null
              }

              let link = item.link
              if (_isUltimate || _isStandard) {
                link = item.openLink
              }

              return (
                <li key={index}>
                  <a href={link}>
                    <img src={item.img} />
                    <p>{item.title}</p>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  })
)
